<template>
  <div
    class="lv-divider"
    :style="{
      'margin-top': marginTop,
      'margin-bottom': marginBottom,
    }"
  ></div>
</template>

<script>
export default {
  props: {
    marginTop: {
      type: String,
      default: '20px',
    },
    marginBottom: {
      type: String,
      default: '20px',
    },
  }
}
</script>